<template>
    <div>
        <profile-form
            v-if="profileForm"
            :is-profile-form-edit="isProfileFormEdit"
            :selected-profile="selectedProfile"
            :channel="channel"
            :broadcast-rights="broadcastRights"
            :profiles="blankingProfiles"
            @leave-form-view="leaveForm"
            @profile-created="profileCreated"
        >
        </profile-form>
        <div
            v-else
            class="profile-list">
            <el-button
                class="button-add"
                icon="el-icon-plus"
                type="primary"
                small
                @click="createNewProfile"
            >
            </el-button>
            <gcmcn-filters
                ref="gcmcn-filters"
                :filter-values="[searchFilter, selectedRegions, selectedTakers]"
                @reset-filters="resetFilters"
            >
                <dropdown
                    name="Regions"
                    :multiple="true"
                    :list="availableRegions" 
                    itemName="display_name"
                    itemValue="uid"
                    :itemsSelected="selectedRegions"
                    @on-select-item="onSelectRegion"
                ></dropdown>
                <dropdown
                    name="Takers"
                    :multiple="true"
                    :list="availableTakers"
                    itemName="name"
                    itemValue="uid"
                    :itemsSelected="selectedTakers"
                    @on-select-item="onSelectTaker"
                ></dropdown>
                <search-filter ref="search" @new-value="searchFilter = $event"></search-filter>
            </gcmcn-filters>
            <div class="profile-card-container" :style="{height: `calc(100vh - ${this.usedHeight}px)`}">
                <template v-if="filteredProfiles.length > 0">
                    <profile-card

                        class="profile-card"
                        v-for="profile in filteredProfiles"
                        :key="profile.uid"
                        :blanking-profile="profile"
                        @edit-profile="editProfile"
                        @on-archived-reload="onArchiveReload"
                    >
                    </profile-card>
                </template>
                <div 
                    v-else-if="blankingProfiles.length > 0 && filteredProfiles.length === 0" 
                    class="list-empty"
                >
                    No profile(s) match this filters.
                </div>
                <div v-else class="list-empty">
                    No profile(s).
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    Dropdown,
    SearchFilter,
    GcmcnFilters,
} from 'gcmcn-common';
import {mapGetters} from 'vuex';
import ProfileForm from './profile-form.vue';
import ProfileCard from './profile-card.vue';
export default {
    components: {
        ProfileForm,
        ProfileCard,
        Dropdown,
        SearchFilter,
        GcmcnFilters,
    },
    name: 'index',
    props:{
        blankingProfiles:{
            type: Array,
            reqiured: true
        },
        channel: {
            type: Object,
            required: true,
        },
        broadcastRights: {
            type: Array,
            required: true,
        },
    },
    data () {
        return {
            profileForm: false,
            selectedProfile: null,
            isProfileFormEdit: false,
            usedHeight: 0,
            searchFilter: '',
            selectedRegions: [],
            selectedTakers: [],
        };
    },
    computed: {
        ...mapGetters([
            'windowWidth',
            'takers',
            'awsregionsSortedByName',
        ]),
        filteredProfiles (){
            let blankingProfiles = this.blankingProfiles.slice();
            if(this.selectedRegions.length > 0){
                blankingProfiles = blankingProfiles.filter((blankingProfile) => this.selectedRegions.includes(blankingProfile.aws_region.uid));
            }
            if(this.selectedTakers.length > 0){
                blankingProfiles = blankingProfiles.filter((blankingProfile) => {
                    return blankingProfile.takers_uid.filter(taker => this.selectedTakers.includes(taker)).length > 0;
                });
            }
            if(this.searchFilter.length > 0){
                let searchFilter = this.searchFilter.toLowerCase();
                blankingProfiles = blankingProfiles.filter((blankingProfile) => blankingProfile.name.toLowerCase().includes(searchFilter));
            }
            return blankingProfiles;
        },
        availableRegions(){
            let regionsInList = this.blankingProfiles.map(blankingProfile => blankingProfile.aws_region.uid);
            let availableRegions = [... new Set(regionsInList)];
            let filteredRegions = this.awsregionsSortedByName.filter(region => availableRegions.includes(region.uid));
            return filteredRegions;
        },
        availableTakers(){
            let takersInList = this.blankingProfiles.map(blankingProfile => blankingProfile.takers_uid);
            takersInList = takersInList.flat();
            let availableTakers = [... new Set(takersInList)];
            let filteredTakers = this.takers.filter(taker => availableTakers.includes(taker.uid));
            return filteredTakers;
        }
    },
    watch: {
        windowWidth (){
            this.computeFilterHeight();
        },
    },
    methods:{
        resetFilters (){
            this.$set(this, 'selectedRegions', []);
            this.$set(this, 'selectedTakers', []);
            this.$refs.search.clear();
        },
        onSelectRegion(regions){
            this.$set(this, 'selectedRegions', regions);
        },
        onSelectTaker(takers){
            this.$set(this, 'selectedTakers', takers);
        },
        createNewProfile(){
            this.profileForm = true;
        },
        leaveForm(){
            this.profileForm = false;
            this.isProfileFormEdit = false;
        },
        editProfile(selectedProfile){
            this.selectedProfile = selectedProfile;
            this.profileForm = true;
            this.isProfileFormEdit = true;
        },
        onArchiveReload(){
            this.updateDataList();
        },
        updateDataList(){
            this.$emit('update-data-list');
        },
        profileCreated(){
            this.profileForm = false;
            this.updateDataList();
        },
        setViewHeight(){
            this.$nextTick(()=>{
                this.computeFilterHeight();
            });
        },
        computeFilterHeight() {
            if(this.$refs['gcmcn-filters']){
                const clientRect = this.$refs['gcmcn-filters'].$el.getBoundingClientRect();
                this.usedHeight = clientRect.top + clientRect.height + 10 + 32; // +10 par ce que l'element contient un margin, et les margin ne sont pas comptés dans la height d'un element
                // 32 -> on enleve la height du wrapper d'alerte de fundation
            }
        },
    },
};
</script>

<style lang="css" scoped>
.button-add{
    position: absolute;
    right: 0;
    top:  0;
    width: 24px;
    height: 24px;
    float: right;
    background: #409EFF;
    border-radius: 2px;
    align-items: center;
    justify-content: center;
    display: flex;
    margin: 1.5rem 2rem 0 5rem;
}
.profile-card-container{
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 5px;
}
.profile-list{
    padding: 3rem 2rem;
    border-radius: 5px;
    background: linear-gradient(180deg, #222222 0%, #111111 61.77%);
}
.profile-card{
    margin-top: 2em;
}
</style>


// WEBPACK FOOTER //
// src/components/page/Channels/Profiles/index.vue